/** Orb animasi Jenna — titik masuk publik. Re-export saja, tanpa logika. */
export { AssistantOrb } from "./assistant-orb";
export { buildColorRamp, type Rgb, sampleRamp } from "./orb-colors";
export { orbLoopSize, subscribeToOrbLoop } from "./orb-loop";
export { shouldAnimateOrb } from "./orb-motion";
export { renderOrbFrame } from "./orb-renderers";
export { OrbStatic } from "./orb-static";
export { type OrbColors, resolveOrbColors } from "./orb-theme";
